"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Parser = _interopRequireDefault(require("@/components/FormGenerator/components/parser/Parser"));
var logistics = _interopRequireWildcard(require("@/api/logistics.js"));
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'CompanyList',
  components: {
    parser: _Parser.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      // 表单
      formConf: {
        fields: []
      },
      form: {
        keywords: ''
      },
      tableData: [],
      page: 1,
      limit: this.$constants.page.limit[0],
      loading: false,
      dialogVisible: false,
      fromType: 'add',
      formData: {
        status: false
      },
      isCreate: 0,
      formShow: false,
      editId: 0
    };
  },
  created: function created() {
    this.getExpressList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //  获取物流公司列表
    getExpressList: function getExpressList() {
      var _this = this;
      this.loading = true;
      logistics.expressAllApi().then(function (res) {
        _this.loading = false;
        _this.tableData = res;
      }).catch(function () {
        _this.loading = false;
      });
    }
  }
};